import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, FileText, ExternalLink } from "lucide-react";
import { resolveUrl } from "@/lib/api";
import { EASE } from "@/lib/motion";

export const BrandCard = ({ brand, categoryMap = {}, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-5% 0px" }}
    transition={{ duration: 0.7, ease: EASE, delay: Math.min(index % 4, 3) * 0.06 }}
  >
    <Link to={`/brands/${brand.slug}`} data-testid={`brand-card-${brand.slug}`} className="group block">
      <div className="img-frame aspect-[4/5] rounded-sm">
        <img src={resolveUrl(brand.hero_image_url)} alt={brand.name} loading="lazy" className="absolute inset-0" />
        <div className="absolute inset-0 bg-[var(--ink)]/0 group-hover:bg-[var(--ink)]/20 transition-colors duration-500" />
        {brand.logo_url && (
          <div className="absolute left-4 bottom-4 h-16 w-16 bg-[var(--cream)] rounded-sm p-1.5 shadow-sm">
            <img src={resolveUrl(brand.logo_url)} alt="" className="h-full w-full object-contain" />
          </div>
        )}
        <div className="absolute top-4 left-4 flex gap-2">
          {brand.is_new && <span className="eyebrow bg-[var(--terracotta)] text-[var(--cream)] px-2.5 py-1 rounded-full !text-[0.6rem]" data-testid={`brand-new-badge-${brand.slug}`}>New</span>}
          {brand.pdf_url && <span className="bg-[var(--cream)]/90 text-[var(--ink)] p-1.5 rounded-full" title="Catalogue available"><FileText size={12} /></span>}
        </div>
        <span className="absolute right-4 top-4 h-9 w-9 rounded-full bg-[var(--cream)] text-[var(--ink)] grid place-items-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
          <ArrowUpRight size={16} />
        </span>
      </div>
      <div className="pt-4 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-display text-xl leading-tight text-[var(--ink)] group-hover:text-[var(--terracotta)] transition-colors">{brand.name}</h3>
          {brand.tagline && <p className="text-sm text-[var(--muted)] mt-1 line-clamp-1 font-light">{brand.tagline}</p>}
        </div>
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {brand.categories.slice(0, 3).map((c) => (
          <span key={c} className="text-[0.68rem] tracking-[0.08em] uppercase text-[var(--charcoal)]/70">{categoryMap[c] || c}{brand.categories.indexOf(c) < Math.min(brand.categories.length, 3) - 1 ? " ·" : ""}</span>
        ))}
      </div>
    </Link>
    {brand.website_url && (
      <a
        href={brand.website_url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`brand-website-btn-${brand.slug}`}
        className="btn-pill btn-terracotta mt-3 !py-2.5 !px-5 !text-[0.7rem]"
      >
        View their website <ExternalLink size={12} />
      </a>
    )}
  </motion.div>
);
